import { StyleSheet } from 'react-native'

const styles = StyleSheet.create({
    comments: {
        flexDirection: 'row',
        alignItems: 'flex-start',
        marginHorizontal: 12,
    },
    avatarContainer: {
        marginRight: 0,
    },
    avatar: {
        width: 35,
        height: 35,
        borderRadius: 20,
        marginTop: 0,
    },
    commentsContent: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'flex-start',
    },
    commentsBlockBottom: {
        flex: 1,
        //padding: 10,
        borderRadius: 10,
        marginLeft: 10,
        marginBottom: 0,
    },
    commentHeader: {
        flexDirection: 'row',
        alignItems: 'center', // Alinear verticalmente
        gap: 4,
    },
    commentFooter: {
        flexDirection: 'row',
        alignItems: 'center', // Alinear verticalmente
        marginTop: 5,
        gap: 4,
    },
    commentsLikeCuore: {
        justifyContent: 'center',
        alignItems: 'center',
        alignContent: 'center',
    },
    answerLikeCuore: {
        justifyContent: 'center',
        alignItems: 'center',
    },
    likesCount: {
        fontSize: 11,
        fontWeight: 'normal',
        alignSelf: 'center',
        textAlign: 'center',
    },
    reply: {
        flexDirection: 'row',
        alignItems: 'flex-start',
        marginLeft: 57, // Indentación para las respuestas
        marginRight: 12,
    },
    replyAvatarContainer: {
        //marginRight: 10,
    },
    replyAvatar: {
        width: 25,
        height: 25,
        borderRadius: 15,
        marginTop: 5,
    },
    replyContent: {
        flex: 1,
        paddingBottom: 0,
        marginLeft: 10,
        justifyContent: 'center',
        marginBottom: 10,
    },
    iconPosts: {
        alignSelf: 'center',
    },
    see: {
        marginTop: 0,
        marginBottom: 0,
        marginLeft: 57,
    },
    hide: {
        marginTop: 0,
        marginBottom: 10,
        marginLeft: 57,
    },
})

export default styles
